import { IUser } from '../../types/auth.types';
import instance from './axios';

const ENDPOINTS = {
  USERS: '/users',
};

export type UserFilter = {
  search?: string;
  staff?: number;
  is_online?: number;
};

const getUsers = ({ search = '', ...props }: UserFilter) => {
  return instance.get<{
    data: {
      total: number;
      data: IUser[];
    };
  }>(ENDPOINTS.USERS, {
    params: {
      search,
      ...props,
    },
  });
};

const UsersApi = {
  getUsers,
};

export default UsersApi;
